"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.InputCounter = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for entry counter
 */
const InputCounter = ({
  currentLength,
  requiredLength,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  className: "ccl__input-counter",
  ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl__input-counter__count ccl__text ccl__text--informative-text",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        display: 'inline-block'
      },
      children: currentLength
    }), "/", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        display: 'inline-block'
      },
      children: requiredLength
    })]
  })
});
exports.InputCounter = InputCounter;
InputCounter.defaultProps = {
  currentLength: 0
};